export default [
  { type: 'visa', level: 'platinum', bin: '431784' },
  { type: 'visa', level: 'infinite', bin: '436505' },
  { type: 'visa', level: 'classic', bin: '438617' },
  { type: 'visa', level: 'gold', bin: '438618' },

  { type: 'masterCard', level: 'platinum', bin: '554639' },
  { type: 'masterCard', level: 'platinum', bin: '554724' },
  { type: 'masterCard', level: 'world', bin: '559959' },

  { type: 'unionPay', level: 'gold', bin: '622675' },
  { type: 'unionPay', level: 'platinum', bin: '622676' },
  { type: 'unionPay', level: 'diamond', bin: '622677' },
  { type: 'unionPay', level: 'diamond(business)', bin: '624329' },

  { type: 'visa', level: 'silver', bin: '424242' }, // ! test card
]



// WEBPACK FOOTER //
// ./src/constants/ccbCards.js